import { LayoutOption } from "../types"

export const slideFrom = (
  layout: LayoutOption,
  way: 'left' | 'right' | 'top' | 'bottom' | 'width' | 'height',
  n: number,
  inside = true
) => {
  if (way === 'left') return n + (inside ? layout.margin : 0)
  if (way === 'right') return layout.slideSize.width - (n + (inside ? layout.margin : 0))
  if (way === 'top') return n + (inside ? layout.margin : 0)
  if (way === 'bottom') return layout.slideSize.height - (n + (inside ? (layout.margin + layout.footerHeight) : 0))
  if (way === 'width') return layout.slideSize.width - (n + (inside ? (layout.margin + layout.margin) : 0))
  if (way === 'height') return layout.slideSize.height - (n + (inside ? (layout.margin + layout.margin + layout.footerHeight) : 0))
  return 0
}
